import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Modal, Form, Table, Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import FormInput from "../../Components/FormInput";
import useCaseDetailsContext from "../../hooks/useCaseDetailsContext";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import '../../styles/common.css'
import { docUrl } from "../../axios";
import DocumentViewerModal from "../DocumentViewerModal";
import Select from "react-dropdown-select";

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";
const typeOptions = [
  { label: "FO", value: "FO" },
  { label: "Internal", value: "INTERNAL" },
];

const AddCaseDocument = ({ show, onHide, editId }) => {
  const { id } = useParams();
  const caseCtx = useCaseDetailsContext();
  const {
    pathname,
    actions,
    caseDetailsLists,
    loadingCaseDetails,
    errorsCaseDetails,
    changedCaseDetailsStatus,
    resetStatusType,
  } = caseCtx;
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState({ url: "", fileName: "" });

  const handleDocumentClick = (documentUrl, fileName) => {
    setSelectedDocument({ url: documentUrl, fileName: fileName || "Document" });
    setShowDocumentModal(true);
  };

  const hideDocumentModal = () => {
    setShowDocumentModal(false);
    setSelectedDocument({ url: "", fileName: "" });
  };

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    setFormData({})
    if(id) {
      dispatch(actions.fetchCaseDetailsById(auth?.token, id, pathname));
    }
  }, [auth, id, pathname, dispatch, actions]);
  

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);

    const updatedFormData = {
      ...formData,
      remark: formData?.remark,
      type: formData?.type || "",
      case_id: id,
    };

    dispatch(actions.saveCaseDocuments(auth?.token, updatedFormData)).then(() => {
      setFormData({});
    });
  };

  
  useEffect(() => {
    if(id && caseDetailsLists && Object.keys(caseDetailsLists)?.length > 0) {
      setFormData({
      });
    }
  }, [caseDetailsLists]);

  useEffect(() => {
    if (errors && Object.keys(errors)?.length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);

  const inputHandler = (e) => {
    const { name, files } = e.target;
  
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: e.target.value });
    }
  };
  
  useEffect(() => {
    if (changedCaseDetailsStatus?.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCaseDetailsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: resetStatusType });
    }
  }, [changedCaseDetailsStatus, dispatch, resetStatusType]);


  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(id && caseDetailsLists && Object.keys(caseDetailsLists)?.length > 0) ? t("Upload Case Document") : t("Add Case Document")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsCaseDetails?.data?.message && (
          <div className="alert alert-danger">
            {errorsCaseDetails?.data?.message}
          </div>
        )}
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Form>
                  <Row>
                    <Col lg={4}>
                      <FormInput
                        label={t("File")}
                        type="file"
                        errors={errorsCaseDetails?.data}
                        name="file"
                        onChange={inputHandler}
                        containerClass={"mb-3"}
                      />
                    </Col>

                    <Col lg={4}>
                      <FormInput
                        label={t("Remarks")}
                        type="text"
                        errors={errorsCaseDetails?.data}
                        value={formData.remark || ""}
                        name="remark"
                        onChange={inputHandler}
                        containerClass={"mb-3"}
                        placeholder={"Enter Remarks"}
                      />
                    </Col>

                    <Col lg={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("Type")}</Form.Label>
                        <Select
                          options={typeOptions}
                          values={typeOptions?.filter((option) => option.value === formData?.type)}
                          name="type"
                          labelField={"label"}
                          valueField={"value"}
                          searchBy={"label"}
                          placeholder={t("Select option")}
                          onChange={(selectedData) => {
                            setFormData((prev) => ({
                              ...prev,
                              type: selectedData?.[0]?.value || "",
                            }));
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} style={{ marginTop: "30px" }}>
                      <Button variant="outline-success" onClick={handleSubmit}>
                        Submit
                      </Button> 
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Table striped bordered hover className="mt-4">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Case Number</th>
                      <th>Name</th>
                      <th>Remark</th>
                      <th>File Type</th>
                      <th>File Name</th>
                      <th>{t("Action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {caseDetailsLists?.length === 0 ? (
                      <tr>
                        <td colSpan="7">No data found</td>
                      </tr>
                    ) : (
                      <>
                        {caseDetailsLists?.case_idCaseDocumentsList?.map?.((doc, index) => (
                          <tr key={doc.id}>
                            <td>{index + 1}</td>
                            <td>{caseDetailsLists?.claim_number}</td>
                            <td>{doc.name}</td>
                            <td>{doc.remark}</td>
                            <td>{doc.file_type}</td>
                            <td>
                            <Badge
                                bg="success"
                                className="me-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDocumentClick(`${docUrl}/uploads/document/${id}/case_document/${doc.upload_file}`, doc.upload_file)}
                              >
                                {doc.upload_file}
                              </Badge>
                            </td>
                            <td>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                disabled={!([1, 2].includes(Number(auth?.data?.user_type_id))|| doc?.createdBy === Number(auth?.data?.id))}
                                onClick={() => {
                                  swal.fire({
                                    title: t("Are you sure?"),
                                    text: t("You want to delete this document?"),
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#d33",
                                    cancelButtonColor: "#3085d6",
                                    confirmButtonText: t("Yes, delete it"),
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      // Pass args in correct order: (token, case_id, document_id, type)
                                      dispatch(
                                        actions.deleteCaseDocument(
                                          auth?.token,
                                          caseDetailsLists?.id,
                                          doc.id,
                                          formData?.type
                                        )
                                      )
                                    }
                                  });
                                }}
                              >
                                {t("Delete")}
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </Table>
                </Card.Body>
            </Card>
          </Col>
        </Row>
        <div className="d-flex justify-content-center">
          <Button variant="dark" onClick={onHide}>
            {t("Close")}
          </Button>
        </div>
        <DocumentViewerModal
          show={showDocumentModal}
          onHide={hideDocumentModal}
          documentUrl={selectedDocument.url}
          fileName={selectedDocument.fileName}
        />
      </Modal.Body>
      {loadingCaseDetails && <Preloader />}
    </Modal>
  );
};

export default AddCaseDocument;
